export const DEFAULT_SETTINGS = {
  phone_display: "0508769282",
  whatsapp: "966508769282",
  hero_badge: "بنشر متنقل نجم الإطارات — خدمة طوارئ 24/7 في الرياض",
  hero_line1: "بنشر متنقل في الرياض",
  hero_line2: "نوصلك إلى موقعك",
  hero_line3: "أينما كنت، متى ما احتجتنا",
  hero_desc: "إطارات، بطاريات، وحساسات TPMS — فريق متنقل بكامل المعدات يصل إليك في أي حي من أحياء الرياض وعلى الطرق السريعة. لا سطحة، لا انتظار ورشة.",
  hero_image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_mobile-tire-service-1/artifacts/clwkm9e3_8f98e44d-bcc3-40fb-a3b3-e21e00f3c3e7.jpg",
  emergency_title: "تعطلت سيارتك؟",
  emergency_sub: "لا تحتاج تسحب السيارة للورشة.",
  hours: "خدمة طوارئ 24 ساعة / 7 أيام",
  location_text: "الرياض — جميع الأحياء والطرق الرئيسية",
  marquee_items: ["بنشر متنقل 24/7", "تغيير إطارات في موقعك", "بطاريات مع الضمان", "برمجة حساسات TPMS", "إصلاح بنشر وثقوب", "طوارئ الطريق", "تغطية كل أحياء الرياض"],
  car_brands: ["تويوتا", "هيونداي", "نيسان", "كيا", "لكزس", "هوندا", "فورد", "شفروليه", "جي إم سي", "مرسيدس", "بي إم دبليو", "جينيسيس", "أخرى"],
  tire_sizes: ["195/65R15", "205/55R16", "215/60R16", "215/55R17", "225/65R17", "235/45R18", "235/55R19", "265/70R17", "275/55R20", "لا أعرف المقاس"],
};

export const DEFAULT_WA_MSG = "السلام عليكم، أحتاج خدمة بنشر متنقل.\nموقعي:\nنوع السيارة:\nالمشكلة:";

export const phoneTel = (display) =>
  `tel:+966${String(display || "").replace(/\D/g, "").replace(/^0/, "")}`;

export const waLink = (msg, num) =>
  `https://wa.me/${num || DEFAULT_SETTINGS.whatsapp}?text=${encodeURIComponent(msg)}`;

export const NAV_LINKS = [
  { id: "home", label: "الرئيسية" },
  { id: "services", label: "خدماتنا" },
  { id: "how", label: "كيف نعمل" },
  { id: "areas", label: "مناطق الخدمة" },
  { id: "gallery", label: "أعمالنا" },
  { id: "reviews", label: "آراء العملاء" },
  { id: "contact", label: "اتصل بنا" },
];
